import { LogeWithOffers } from "~/applications/OfferSearch/Domain/LogeWithOffers";
import { Offer } from "~/applications/OfferSearch/Domain/Offer";

type SortedOffers = {
  numberOfLoges: number;
  isDestinationSoldOut: boolean;
  offersByLoge: Array<LogeWithOffers>;
  soldOutOffers: Array<Offer>;
};

const useOffersSorter = ({
  offers,
}: {
  offers: Array<Offer> | undefined;
}): SortedOffers | undefined => {
  if (offers === undefined || offers.length === 0) {
    return undefined;
  }

  const offersSortedByAvailability = offers.reduce(
    () => {
      return offers.reduce(
        (acc, offer) => {
          if (offer.isSoldOut()) {
            acc.soldOutOffers.push(offer);
          } else {
            acc.availableOffers.push(offer);
          }

          return acc;
        },
        {
          availableOffers: [] as Array<Offer>,
          soldOutOffers: [] as Array<Offer>,
        },
      );
    },
    {} as {
      availableOffers: Array<Offer>;
      soldOutOffers: Array<Offer>;
    },
  );

  const logeWithOffers = offers.reduce((acc, offer) => {
    const loge = acc.find((loge) => loge.id === offer.unitGroup.loge.id);

    if (loge) {
      loge.offers.push(offer);
    } else {
      acc.push({
        ...offer.unitGroup.loge,
        offers: [offer],
        numberOfAvailableOffers: 0,
      });
    }

    return acc;
  }, [] as Array<LogeWithOffers>);

  logeWithOffers.forEach((loge) => {
    loge.offers = loge.offers.filter((oneOffer) => !oneOffer.isSoldOut());
  });

  logeWithOffers.forEach((loge) => {
    loge.numberOfAvailableOffers = loge.offers.length;
  });

  return {
    numberOfLoges: logeWithOffers.length,
    isDestinationSoldOut:
      offersSortedByAvailability.availableOffers.length === 0,
    offersByLoge: logeWithOffers,
    soldOutOffers: offersSortedByAvailability.soldOutOffers,
  };
};

export default useOffersSorter;
